import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ImportFileTemplateService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('ImportFileTemplate');
	}

	loadAll(type: number): Observable<TooBig4Car.Logic.ImportFileTemplate[]> {
		return this.myBaseService.loadAll(this.url + '?type=' + (type ?? 0));
	}
	getColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.FileTemplatePickupDeliveryColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditColumns');
	}
	saveColumn(tempItem: TooBig4Car.Logic.FileTemplatePickupDeliveryColumnMapperVM): Observable<TooBig4Car.Logic.ImportFileTemplate> {
		return this.myBaseService.post(tempItem, this.url + '/EditColumns', true);
	}
	getPropertyColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.FileTemplateTypePropertyColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditPropertyColumns');
	}
	savePropertyColumn(tempItem: TooBig4Car.Logic.FileTemplateTypePropertyColumnMapperVM): Observable<TooBig4Car.Logic.ImportFileTemplate> {
		return this.myBaseService.post(tempItem, this.url + '/EditPropertyColumns', true);
	}

	getPropertyItemColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.FileTemplatePropertyItemColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditPropertyItemColumns');
	}
	savePropertyItemColumn(tempItem: TooBig4Car.Logic.FileTemplatePropertyItemColumnMapperVM): Observable<TooBig4Car.Logic.ImportFileTemplate> {
		return this.myBaseService.post(tempItem, this.url + '/EditPropertyItemColumns', true);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
}
